import SubscribeEmailForm from './SubscribeEmailForm'

export default SubscribeEmailForm
